import { forwardRef, ComponentProps } from "react";

const UploadShareIcon = forwardRef<SVGSVGElement, ComponentProps<"svg">>((props, svgRef) => (
  <svg
    {...props}
    ref={svgRef}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9786 7.33687C14.9757 7.29504 14.9761 7.2844 14.969 7.24299C14.9529 7.14987 14.9176 7.06031 14.8657 6.9813C14.8395 6.94134 14.8091 6.90646 14.7765 6.87162L10.6287 2.7238C10.5981 2.69518 10.5911 2.68719 10.5576 2.66179C10.52 2.63327 10.4794 2.60863 10.4368 2.58834C10.2504 2.49971 10.0293 2.49971 9.84298 2.58834C9.80032 2.60863 9.75978 2.63327 9.72217 2.66179C9.68871 2.68719 9.68169 2.69518 9.65107 2.7238L5.50325 6.87162C5.47463 6.90228 5.46661 6.90929 5.44124 6.94275C5.37456 7.03062 5.32956 7.13431 5.31079 7.24299C5.29744 7.32058 5.29744 7.40033 5.31079 7.47793C5.3215 7.53997 5.34072 7.60049 5.36775 7.65735C5.47044 7.87332 5.68347 8.02368 5.92135 8.04815C6.01536 8.05779 6.11111 8.04794 6.20119 8.01935C6.27623 7.99554 6.34705 7.95887 6.40975 7.9113C6.44325 7.8859 6.45023 7.87791 6.48089 7.84929L10.1399 4.19029L13.7989 7.8493L13.8334 7.88151C13.8659 7.90795 13.8734 7.91549 13.9086 7.93851C13.9744 7.98168 14.0476 8.01348 14.124 8.03211C14.1852 8.04701 14.2484 8.05351 14.3113 8.05136C14.5503 8.04321 14.7731 7.90771 14.8903 7.69928C14.9289 7.63067 14.9556 7.55549 14.969 7.47793C14.9761 7.43652 14.9757 7.42587 14.9786 7.38405C14.9786 7.36832 14.9786 7.35259 14.9786 7.33687Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.7051 10.2943C2.09452 10.2943 2.4102 10.61 2.4102 10.9994L2.4102 15.9183L17.5906 15.9183L17.5906 10.9994C17.5906 10.61 17.9063 10.2943 18.2957 10.2943C18.6851 10.2943 19.0008 10.61 19.0008 10.9994L19.0008 16.6234C19.0008 17.0128 18.6851 17.3285 18.2957 17.3285L1.7051 17.3285C1.31568 17.3285 1 17.0128 1 16.6234L1 10.9994C1 10.61 1.31568 10.2943 1.7051 10.2943Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1523 3.07362C10.5417 3.07362 10.8574 3.38931 10.8574 3.77872L10.8574 13.1524C10.8574 13.5418 10.5417 13.8575 10.1523 13.8575C9.76291 13.8575 9.44722 13.5418 9.44722 13.1524L9.44722 3.77872C9.44722 3.38931 9.76291 3.07362 10.1523 3.07362Z"
      fill="currentColor"
    />
  </svg>
));

UploadShareIcon.displayName = "UploadShareIcon";
export default UploadShareIcon;
